import axios from "axios";
import {
  Branch_Contact_URL,
  Branch_Location_Pincode_URL,
  Master_Service_URL,
  System_URL,
  Lead_Allocation_Service,
  User_Service_URL,
} from "../Url";
import HashMap from "hashmap";
import { clearLogoutData } from "../logout/action";

var map = new HashMap();
var err;
function objToStrMap(obj) {
  let strMap = new Map();
  for (let k of Object.keys(obj)) {
    strMap.set(k, obj[k]);
  }
  return strMap;
}

// Start GET call for branch location

export const getBranchLocationActions = {
  GET_BRANCH_LOCATION_DETAIL_SUCCESS: "GET_BRANCH_LOCATION_DETAIL_SUCCESS",
  GET_BRANCH_LOCATION_DETAIL_ERROR: "GET_BRANCH_LOCATION_DETAIL_ERROR",
};

export function getBranchPreferenceDetail(props) {
  const { accessToken, partnerFirmId } = props;

  // const accessToken = props
  return (dispatch) =>
    axios({
      method: "post",
      url: `${Lead_Allocation_Service}/get/PartnerBranchPreference/ByPartnerFirmId?partnerFirmId=${partnerFirmId}`,
      headers: {
        authorization: "Bearer " + accessToken,
      },
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          dispatch(getbranchLocationSuccess(response.data));
          // dispatch(setLogoutFlag());
          return response;
        } else if (response.status === 401) {
          // return response;
        }
        // else if (response.status === 403) {
        //   const error = new Error(response.statusText);
        //   dispatch(clearLogoutData());
        //   // dispatch(firmDetailMasterError(error))

        //   // return response;
        //   throw error;
        // }
      })
      .catch((err) => {
        if (err.response) {
          map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));

          map.forEach((ele) => (err = ele));

          return err;
        }
      });
}

export function getbranchLocationError(error) {
  return {
    type: getBranchLocationActions.GET_BRANCH_LOCATION_DETAIL_ERROR,
    payload: error,
  };
}

export function getbranchLocationSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: getBranchLocationActions.GET_BRANCH_LOCATION_DETAIL_SUCCESS,
      payload: props,
    });
  };
}

//End GET call for branch location

export const branchLocationActions = {
  FETCH_BRANCH_LOCATION_LIST: "FETCH_BRANCH_LOCATION_LIST",
  FETCH_BRANCH_LOCATION_LIST_SUCCESS: "FETCH_BRANCH_LOCATION_LIST_SUCCESS",
  FETCH_BRANCH_LOCATION_LIST_ERROR: "FETCH_BRANCH_LOCATION_LIST_ERROR",
};

export function saveBranchPrefrenceDetails(props) {
  const { access_token, partnerFirmId, newValues } = props;
  return (dispatch) =>
    axios({
      method: "post",
      headers: {
        authorization: "Bearer " + access_token,
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
      },
      url: `${Lead_Allocation_Service}/save/PartnerBranchPreference`,
      data: newValues,
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          dispatch(getBranchLocationDetailsSuccess(response));
          return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(getBranchLocationDetailsError(error));
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          map = objToStrMap(JSON.parse(JSON.stringify(err.response.data)));

          map.forEach((ele) => (err = ele));
          getBranchLocationDetailsError(err);

          return err;
        }
      });
}
export function getBranchLocationDetailsSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: branchLocationActions.FETCH_BRANCH_LOCATION_LIST_SUCCESS,
      payload: props,
    });
  };
}
export function getBranchLocationDetailsError(error) {
  return {
    type: branchLocationActions.FETCH_BRANCH_LOCATION_LIST_ERROR,
    payload: error,
  };
}

export const getMasterBranchDataActions = {
  GET_MASTER_BRANCH_DATA_SUCCESS: "GET_MASTER_BRANCH_DATA_SUCCESS",
  GET_MASTER_BRANCH_DATA_ERROR: "GET_MASTER_BRANCH_DATA_ERROR",
};

export function getMasterBranchDataDetails(props) {
  const { access_token } = props;

  return (dispatch) =>
    axios({
      method: "post",
      headers: {
        authorization: "Bearer " + access_token,
        "Access-Control-Allow-Origin": "*",
      },
      url: `${Master_Service_URL}/getAll/BranchMaster/DropDown/Pincode`,
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          dispatch(getMasterBranchDataSuccess(response));
          return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(getMasterBranchDataError(error));
          throw error;
        }
      })
      .catch((err) => {
        if (
          err?.response?.status === "403" &&
          err?.response?.data?.error?.logoutStatus
        ) {
          dispatch(clearLogoutData());
        } else {
          if (err.response) {
            dispatch(getMasterBranchDataError(err));
            return err.response;
          }
        }
      });
}

export function getMasterBranchDataError(error) {
  return {
    type: getMasterBranchDataActions.GET_MASTER_BRANCH_DATA_ERROR,
    payload: error,
  };
}

export function getMasterBranchDataSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: getMasterBranchDataActions.GET_MASTER_BRANCH_DATA_SUCCESS,
      payload: props,
    });
  };
}

export const pincodeListActions = {
  PINCODE_LIST: "PINCODE_LIST",
  PINCODE_LIST_SUCCESS: "PINCODE_LIST_SUCCESS",
  PINCODE_LIST_ERROR: "PINCODE_LIST_ERROR",
  LOGOUT: "LOGOUT",
};

export function getPincodeOnSearch(props) {
  const { access_token, inputValue } = props;

  return (dispatch) =>
    axios({
      method: "post",
      headers: {
        authorization: "Bearer " + access_token,
        "Access-Control-Allow-Origin": "*",
      },
      url:
        `${Branch_Location_Pincode_URL}/search/Pincode?pincode=` + inputValue,
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          dispatch(getPincodeListSuccess(response));
          return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(getPincodeListError(error));
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          dispatch(getPincodeListError(err));
          return err.response;
        }
      });
}

export function getPincodeListRequest() {
  return {
    type: pincodeListActions.PINCODE_LIST,
    isPosting: true,
  };
}
export function getPincodeListError(error) {
  return {
    type: pincodeListActions.PINCODE_LIST_ERROR,
    payload: error,
  };
}

export function getPincodeListSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: pincodeListActions.PINCODE_LIST_SUCCESS,
      payload: props,
    });
  };
}

export const getBranchLocationByPincodeActions = {
  GET_BRANCH_LOCATION_BY_PINCODE: "GET_BRANCH_LOCATION_BY_PINCODE",
  GET_BRANCH_LOCATION_BY_PINCODE_SUCCESS:
    "GET_BRANCH_LOCATION_BY_PINCODE_SUCCESS",
  GET_BRANCH_LOCATION_BY_PINCODE_ERROR: "GET_BRANCH_LOCATION_BY_PINCODE_ERROR",
  LOGOUT: "LOGOUT",
};

export function getBranchLocationByPincode(props) {
  const { access_token, url, data, pincode } = props;
  return (dispatch) =>
    axios({
      method: "post",
      headers: {
        authorization: "Bearer " + access_token,
        "Access-Control-Allow-Origin": "*",
      },

      url: `${Branch_Location_Pincode_URL}/${url}?pincodeId=` + pincode,
      data: data,
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          dispatch(getBranchLocationByPincodeSuccess(response));
          return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(getBranchLocationByPincodeError(error));
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          dispatch(getBranchLocationByPincodeError(err));
          return err.response;
        }
      });
}

export function getBranchLocationByPincodeRequest() {
  return {
    type: getBranchLocationByPincodeActions.GET_BRANCH_LOCATION_BY_PINCODE,
    isPosting: true,
  };
}
export function getBranchLocationByPincodeError(error) {
  return {
    type: getBranchLocationByPincodeActions.GET_BRANCH_LOCATION_BY_PINCODE_ERROR,
    payload: error,
  };
}

export function getBranchLocationByPincodeSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: getBranchLocationByPincodeActions.GET_BRANCH_LOCATION_BY_PINCODE_SUCCESS,
      payload: props,
    });
  };
}

export const getBranchLocationByAreaActions = {
  GET_BRANCH_LOCATION_BY_AREA: "GET_BRANCH_LOCATION_BY_AREA",
  GET_BRANCH_LOCATION_BY_AREA_SUCCESS: "GET_BRANCH_LOCATION_BY_AREA_SUCCESS",
  GET_BRANCH_LOCATION_BY_AREA_ERROR: "GET_BRANCH_LOCATION_BY_AREA_ERROR",
  LOGOUT: "LOGOUT",
};
export function getBranchLocationByArea(props) {
  const { access_token, url, pincode, data } = props;
  return (dispatch) =>
    axios({
      method: "post",
      headers: {
        authorization: "Bearer " + access_token,
        "Access-Control-Allow-Origin": "*",
      },

      url: `${Branch_Location_Pincode_URL}/${url}?pincode=` + pincode,
      data: data,
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          dispatch(getBranchLocationByAreaSuccess(response));
          return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(getBranchLocationByAreaError(error));
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          dispatch(getBranchLocationByAreaError(err));
          return err.response;
        }
      });
}

export function getLocMasterByAreaRequest() {
  return {
    type: getBranchLocationByAreaActions.GET_BRANCH_LOCATION_BY_AREA,
    isPosting: true,
  };
}
export function getBranchLocationByAreaError(error) {
  return {
    type: getBranchLocationByAreaActions.GET_BRANCH_LOCATION_BY_AREA_ERROR,
    payload: error,
  };
}

export function getBranchLocationByAreaSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: getBranchLocationByAreaActions.GET_BRANCH_LOCATION_BY_AREA_SUCCESS,
      payload: props,
    });
  };
}

// CR of Branch Prefernces

export const getMasterDropDownActions = {
  GET_DROPDOWN_DATA_SUCCESS: "GET_DROPDOWN_DATA_SUCCESS",
  GET_DROPDOWN_DATA_ERROR: "GET_DROPDOWN_DATA_ERROR",
};

export function getMasterDropDownDetails(props) {
  const { access_token, value } = props;

  return (dispatch) =>
    axios({
      method: "post",
      headers: {
        authorization: "Bearer " + access_token,
        "Access-Control-Allow-Origin": "*",
      },
      url: `${Lead_Allocation_Service}/getAll/AvanseBranchMaster/DropDown/Excluding`,
      data: value,
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          dispatch(getMasterDropDownSuccess(response));
          return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(getMasterDropDownError(error));
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          dispatch(getMasterDropDownError(err));
          return err.response;
        }
      });
}

export function getMasterDropDownError(error) {
  return {
    type: getMasterDropDownActions.GET_DROPDOWN_DATA_ERROR,
    payload: error,
  };
}

export function getMasterDropDownSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: getMasterDropDownActions.GET_DROPDOWN_DATA_SUCCESS,
      payload: props,
    });
  };
}

export const getSMRoleDropDownActions = {
  GET_SMROLE_DROPDOWN_DATA_SUCCESS: "GET_SMROLE_DROPDOWN_DATA_SUCCESS",
  GET_SMROLE_DROPDOWN_DATA_ERROR: "GET_SMROLE_DROPDOWN_DATA_ERROR",
};

export function getSMRoleDropDownDetails(props) {
  const { access_token, avanseBranchId } = props;

  return (dispatch) =>
    axios({
      method: "post",
      headers: {
        authorization: "Bearer " + access_token,
        "Access-Control-Allow-Origin": "*",
      },
      url: `${User_Service_URL}/getAll/UserMaster/ByRoleTypeAndAvanseBranchIds?roleType=SM_ASM_BSM&avanseBranchIds=${avanseBranchId}`,
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          dispatch(getSMRoleDropDownSuccess(response));
          return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(getSMRoleDropDownError(error));
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          dispatch(getSMRoleDropDownError(err));
          return err.response;
        }
      });
}

export function getSMRoleDropDownError(error) {
  return {
    type: getSMRoleDropDownActions.GET_SMROLE_DROPDOWN_DATA_ERROR,
    payload: error,
  };
}

export function getSMRoleDropDownSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: getSMRoleDropDownActions.GET_SMROLE_DROPDOWN_DATA_SUCCESS,
      payload: props,
    });
  };
}

export const getPrefrenceDetailsActions = {
  GET_PREFRENCE_DATA_SUCCESS: "GET_PREFRENCE_DATA_SUCCESS",
  GET_PREFRENCE_DATA_ERROR: "GET_PREFRENCE_DATA_ERROR",
};

export function getPrefrenceDetailsDetails(props) {
  const { access_token, partnerFirmId } = props;

  return (dispatch) =>
    axios({
      method: "post",
      headers: {
        authorization: "Bearer " + access_token,
        "Access-Control-Allow-Origin": "*",
      },
      url: `${Lead_Allocation_Service}/get/PartnerBranchPreference/ByPartnerFirmId?partnerFirmId=${partnerFirmId}`,
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          dispatch(getPrefrenceDetailsSuccess(response));
          return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(getPrefrenceDetailsError(error));
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          dispatch(getPrefrenceDetailsError(err));
          return err.response;
        }
      });
}

export function getPrefrenceDetailsError(error) {
  return {
    type: getPrefrenceDetailsActions.GET_PREFRENCE_DATA_ERROR,
    payload: error,
  };
}

export function getPrefrenceDetailsSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: getPrefrenceDetailsActions.GET_PREFRENCE_DATA_SUCCESS,
      payload: props,
    });
  };
}

export const savePrefrenceDetailsActions = {
  SAVE_PREFRENCE_DATA_SUCCESS: "SAVE_PREFRENCE_DATA_SUCCESS",
  SAVE_PREFRENCE_DATA_ERROR: "SAVE_PREFRENCE_DATA_ERROR",
};

export function savePrefrenceDetailsDetails(props) {
  const { access_token, partnerFirmId, value } = props;

  return (dispatch) =>
    axios({
      method: "post",
      headers: {
        authorization: "Bearer " + access_token,
        "Access-Control-Allow-Origin": "*",
      },
      url: `${Lead_Allocation_Service}/save/PartnerBranchPreference?partnerFirmId=${partnerFirmId}`,
      data: value,
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          dispatch(savePrefrenceDetailsSuccess(response));
          return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(savePrefrenceDetailsError(error));
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          dispatch(savePrefrenceDetailsError(err));
          return err.response;
        }
      });
}

export function savePrefrenceDetailsError(error) {
  return {
    type: savePrefrenceDetailsActions.SAVE_PREFRENCE_DATA_ERROR,
    payload: error,
  };
}

export function savePrefrenceDetailsSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: savePrefrenceDetailsActions.SAVE_PREFRENCE_DATA_SUCCESS,
      payload: props,
    });
  };
}

export const deletePrefrenceDetailsActions = {
  DELETE_PREFRENCE_DATA_SUCCESS: "DELETE_PREFRENCE_DATA_SUCCESS",
  DELETE_PREFRENCE_DATA_ERROR: "DELETE_PREFRENCE_DATA_SUCCESS",
};

export function deletePrefrenceDetailsDetails(props) {
  const { access_token, partnerBranchPreferenceId } = props;

  return (dispatch) =>
    axios({
      method: "post",
      headers: {
        authorization: "Bearer " + access_token,
        "Access-Control-Allow-Origin": "*",
      },
      url: `${Lead_Allocation_Service}/deactivate/PartnerBranchPreference/ByPartnerBranchPreferenceId?partnerBranchPreferenceId=${partnerBranchPreferenceId}`,
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          dispatch(deletePrefrenceDetailsSuccess(response));
          return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(deletePrefrenceDetailsError(error));
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          dispatch(deletePrefrenceDetailsError(err));
          return err.response;
        }
      });
}

export function deletePrefrenceDetailsError(error) {
  return {
    type: deletePrefrenceDetailsActions.DELETE_PREFRENCE_DATA_ERROR,
    payload: error,
  };
}

export function deletePrefrenceDetailsSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: deletePrefrenceDetailsActions.DELETE_PREFRENCE_DATA_SUCCESS,
      payload: props,
    });
  };
}
